export enum OpnRenderType {
	Builder = 'builder',
	Form = 'form'
}